import APIClient from '@/shared/http/clients/api'

const resourceName = 'QuadroFuncionarioItem'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const GetAll = (quadrofuncionarioID, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/quadrofuncionario/${quadrofuncionarioID}`, data, config)
const GetAllPaging = (quadrofuncionarioID, limit, index, sortField = 'codigo', sortType = 'ASC', config = {}) =>
  APIClient.get(`${APIBusinessCommon}/${resourceName}/quadrofuncionario/${quadrofuncionarioID}?limit=${limit}&index=${index}&sortfield=${sortField}&sorttype=${sortType}`, config)
const GetById = (id, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/${id}`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APIBusinessCommon}/${resourceName}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APIBusinessCommon}/${resourceName}/${id}`, config)
const Clone = (id, newID, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/clone/${id}/${newID}`, config)

const EmployeeBoardItemRepository = {
  GetAll,
  GetAllPaging,
  GetById,
  Create,
  Update,
  Delete,
  Clone
}

export default EmployeeBoardItemRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/employeeboarditem.js